var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-booking-locations"},[_c('md-card',[_c('md-card-header',[_c('h4',{staticStyle:{"margin":"0"}},[_vm._v("Booking Locations")])]),_c('md-card-content',[_c('div',{staticClass:"map"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }